var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_582_2723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46997 8.00006H1.96997C1.005 8.00006 0.220032 7.21509 0.220032 6.24994V1.74994C0.220032 0.784973 1.005 0 1.96997 0H9.46997C10.4351 0 11.2201 0.784973 11.2201 1.74994V6.24994C11.2201 7.21509 10.4351 8.00006 9.46997 8.00006ZM1.96997 1.5C1.83209 1.5 1.72003 1.61206 1.72003 1.74994V6.24994C1.72003 6.388 1.83209 6.50006 1.96997 6.50006H9.46997C9.60803 6.50006 9.72009 6.388 9.72009 6.24994V1.74994C9.72009 1.61206 9.60803 1.5 9.46997 1.5H1.96997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46997 24.0001H1.96997C1.005 24.0001 0.220032 23.2151 0.220032 22.2501V11.7501C0.220032 10.785 1.005 10 1.96997 10H9.46997C10.4351 10 11.2201 10.785 11.2201 11.7501V22.2501C11.2201 23.2151 10.4351 24.0001 9.46997 24.0001ZM1.96997 11.5C1.83209 11.5 1.72003 11.6121 1.72003 11.7501V22.2501C1.72003 22.388 1.83209 22.5001 1.96997 22.5001H9.46997C9.60803 22.5001 9.72009 22.388 9.72009 22.2501V11.7501C9.72009 11.6121 9.60803 11.5 9.46997 11.5H1.96997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4701 23.9999H14.9701C14.0049 23.9999 13.22 23.215 13.22 22.25V17.75C13.22 16.7849 14.0049 15.9999 14.9701 15.9999H22.4701C23.4351 15.9999 24.22 16.7849 24.22 17.75V22.25C24.22 23.215 23.4351 23.9999 22.4701 23.9999ZM14.9701 17.4999C14.832 17.4999 14.72 17.6119 14.72 17.75V22.25C14.72 22.3879 14.832 22.4999 14.9701 22.4999H22.4701C22.608 22.4999 22.72 22.3879 22.72 22.25V17.75C22.72 17.6119 22.608 17.4999 22.4701 17.4999H14.9701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4701 14.0001H14.9701C14.0049 14.0001 13.22 13.2151 13.22 12.2499V1.74994C13.22 0.784973 14.0049 0 14.9701 0H22.4701C23.4351 0 24.22 0.784973 24.22 1.74994V12.2499C24.22 13.2151 23.4351 14.0001 22.4701 14.0001ZM14.9701 1.5C14.832 1.5 14.72 1.61206 14.72 1.74994V12.2499C14.72 12.388 14.832 12.5001 14.9701 12.5001H22.4701C22.608 12.5001 22.72 12.388 22.72 12.2499V1.74994C22.72 1.61206 22.608 1.5 22.4701 1.5H14.9701Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_582_2723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.220032)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlack);
export default __webpack_public_path__ + "static/media/Dashboard_Black.04c9b29689ec2b17a6b7f5e05c16b6c9.svg";
export { ForwardRef as ReactComponent };